module.exports = "img/taller-ab-3.e095cc.jpg";